import request from '@/plugin/axios'

export function myInfo() {
  return request({
    url: '/api-base/user/myInfo',
    method: 'get'
  })
}
export function msgInit() {
  return request({
    url: '/api-mailbox/mails/selectFinishStatistic',
    method: 'get'
  })
}
export function HandleMailDepts() {
  return request({
    url: '/api-base/department/findDeptTreeOne',
    method: 'post'
  })
}
//修改信件内容
export function updateLetterContent(data) {
  return request({
    url: '/api-mailbox/mails/updateContent',
    method: 'post',
    data
  })
}
//修改信件标题
export function updateLetterTitleName(params) {
  return request({
    url: '/api-mailbox/mails/updateTitle',
    method: 'post',
    params
  })
}
//修改来信目的
export function updateObjectiveType(params) {
  return request({
    url: '/api-mailbox/mails/updateObjectiveType',
    method: 'post',
    params
  })
}
//信件修改回复
export function updateReply(data) {
  return request({
    url: '/api-mailbox/mailOperate/updateReply',
    method: 'post',
    data
  })
}
//意见征集统计
export function collectRecord(data) {
  return request({
    url: '/api-collect/article/collectRecord',
    method: 'post',
    data
  })
}
//问卷调查统计
export function paperRecord(data) {
  return request({
    url: '/api-question/questionPaper/paperRecord',
    method: 'post',
    data
  })
}
//意见征集部门
export function opinionDeptTree() {
  return request({
    url: '/api-base/department/findDeptTreeOne',
    method: 'post'
  })
}
//意见征集留言查询
export function msgListSearch(data) {
  return request({
    url: '/api-collect/article/allMessageList',
    method: 'post',
    data
  })
}
//打印功能
export function print(operateId, operateType) {
  return request({
    url: '/api-common/file/expMailTempById?operateId=' + operateId + '&operateType=' + operateType,
    method: 'get'
  })
}
//日历图数据显示
export function showCalendar(params) {
  return request({
    url: '/api-base/workBench/getCalenderByDay',
    method: 'post',
    params
  })
}

//意见征集附件上传限制
export function fileLimit() {
  return request({
    url: 'api-common/common/businessType?type=COLLECTION_FILE',
    method: 'get'
  })
}
//获取转办部门树
export function zhuanbanDeptTree(getData) {
  return request({
    url: '/api-base/department/myDeptTree?operateId=' + getData + '&type=assign',
    method: 'post'
  })
}
//新增信件附件上传限制
export function mailFileLimit() {
  return request({
    url: 'api-common/common/businessType?type=MAIL_INFO_FILE',
    method: 'get'
  })
}
//回复信件附件上传限制
export function replyMailFileLimit() {
  return request({
    url: 'api-common/common/businessType?type=MAIL_REPLY_FILE',
    method: 'get'
  })
}

//获取信箱督办列表
export function listReminder(getData) {
  return request({
    url: '/api-mailbox/mailReminder/listReminder?operateId=' + getData + '&type=all',
    method: 'get'
  })
}
//批量修改管理部门
export function BatchManageDepts(data) {
  return request({
    url: '/api-base/user/updateBatchManageDepts',
    method: 'post',
    data
  })
}
export function getprintData(params) {
  return request({
    url: '/api-common/file/expMailTemp',
    method: 'post',
    params
  })
}
//获取信箱督办列表
export function listReminder2(getData) {
  return request({
    url: '/api-mailbox/mailReminder/listReminder?operateId=' + getData,
    method: 'get'
  })
}
//角色管理下拉框
export function allRoles() {
  return request({
    url: '/api-base/role/allRoles',
    method: 'get'
  })
}
//用户管理下拉框
export function getDeptTree(params) {
  return request({
    url: '/api-base/department/deptTree',
    method: 'post',
    params
  })
}
//获取信件统计查询按钮
export function getReportList(data) {
  return request({
    url: '/api-mailbox/mails/getReportList',
    method: 'post',
    data
  })
}
//获取意见征集业务分类
export function business(params) {
  return request({
    url: '/api-common/common/businessType',
    method: 'post',
    params
  })
}
//获取意见征集查询部门
export function checkDeptTree() {
  return request({
    url: '/api-base/department/deptTree',
    method: 'post'
  })
}
//获取问卷调查部门根据用户
export function checkDeptTreeByUser() {
  return request({
    url: '/api-question/questionPaper/deptTree',
    method: 'post'
  })
}

////获取意见征集预览
export function sendOutjoin(params) {
  return request({
    url: '/api-common/common/outjoin',
    method: 'post',
    params
  })
}
//意见征集新增留言
export function lyMessage(data) {
  return request({
    url: '/api-collect/article/lyMessage',
    method: 'post',
    data
  })
}
//附件检测
export function checkContent(data) {
  return request({
    url: '/api-common/sensitive/content',
    method: 'post',
    data
  })
}
//获取征集部门
export function deptTree(data) {
  return request({
    url: '/api-collect/article/deptTree',
    method: 'post',
    data
  })
}

export function getStatisticCode() {
  return request({
    url: '/api-base/workBench/getStatisticCode',
    method: 'post'
  })
}
export function getStatisticData(params) {
  return request({
    url: '/api-base/workBench/getStatisticData',
    method: 'post',
    params
  })
}
export function LoginUser(params) {
  return request({
    url: '/api-base/login',
    method: 'post',
    params
  })
}
export function ChartChoiceList(params) {
  return request({
    url: '/api-base/workBench/ChartChoiceList',
    method: 'post',
    params
  })
}
export function ChartData(params) {
  return request({
    url: '/api-base/workBench/ChartData',
    method: 'post',
    params
  })
}
export function getIntDate(data) {
  return request({
    url: 'api-base/workBench/intDate',
    method: 'post',
    data
  })
}
export function LogoutUser(params) {
  return request({
    url: '/api-base/logout',
    method: 'post',
    params
  })
}
export function GetMenus(data) {
  return request({
    url: '/api-base/res/menu',
    method: 'post',
    data
  })
}
export function GetPageListData(data) {
  return request({
    url: '/api-mailbox/mails/getPageList',
    method: 'post',
    data
  })
}
export function GetPageListDataEntrust(data) {
  return request({
    url: '/api-mailbox/mailOperate/pageList',
    method: 'post',
    data
  })
}
export function getMail(data) {
  return request({
    url: '/api-mailbox/mails/getStatistics',
    method: 'post',
    data
  })
}
export function getinterviewQA(data) {
  return request({
    url: '/api-inter/interviewQA/interviewStatistics',
    method: 'post',
    data
  })
}
export function getinterview(data) {
  return request({
    url: '/api-inter/interview/interviewStatistics',
    method: 'post',
    data
  })
}
export function getRecord(data) {
  return request({
    url: '/api-question/questionPaper/record',
    method: 'post',
    data
  })
}
export function getArticle(data) {
  return request({
    url: '/api-collect/article/record',
    method: 'post',
    data
  })
}
export function GetLetterSearch(data) {
  return request({
    url: '/api-mailbox/mails/getPageList',
    method: 'post',
    data
  })
}
export function GetLetterSelectType(data) {
  return request({
    url: '/api-mailbox/dict/getDictByConditionList',
    method: 'post',
    data
  })
}
export function GetSelectContentListData() {
  return request({
    url: '/api-mailbox/dict/selectDictByBizTypeAll?bizType=BIZ_MAIL_INFO.CONTENT_TYPE',
    method: 'get'
  })
}
export function GetDictByConditionList(data) {
  return request({
    url: '/api-mailbox/dict/getDictByConditionList?time=2',
    method: 'post',
    data
  })
}
export function GetDeptTree() {
  return request({
    url: '/api-base/department/deptTree',
    method: 'post'
  })
}
export function currutGetDeptTree() {
  return request({
    url: '/api-base/department/myDeptTree',
    method: 'post'
  })
}
//获取交办部门树
export function jiaobanDeptTree(getData) {
  return request({
    url: '/api-base/department/myDeptTree?operateId=' + getData + '&type=delegate',
    method: 'post'
  })
}
//获取督办部门树
export function dubanDeptTree(getData) {
  return request({
    url: '/api-base/department/myDeptTree?operateId=' + getData + '&type=reminder',
    method: 'post'
  })
}
//批量修改用户
export function updateBatchRoles(data) {
  return request({
    url: '/api-base/user/updateBatchRoles',
    method: 'post',
    data
  })
}
//请求来源统计表格
export function getSource(data) {
  return request({
    url: 'api-mailbox/mails/getSourceByParams',
    method: 'post',
    data
  })
}
//请求类型统计表格
export function getObject(data) {
  return request({
    url: 'api-mailbox/mails/getObjectByParams',
    method: 'post',
    data
  })
}

//请求主站点
export function deptSite() {
  return request({
    url: 'api-supervise/superviseSite/deptSite',
    method: 'post'
  })
}
//请求副站点
export function superviseSiteInfo() {
  return request({
    url: 'api-supervise/superviseSite/superviseSiteInfo',
    method: 'post'
  })
}
//获取征集部门
export function selectDeptBySiteId(params) {
  return request({
    url: 'api-supervise/superviseSite/selectDeptBySiteId',
    method: 'post',
    params
  })
}
//请求部门考核表格
export function getReport(data) {
  return request({
    url: 'api-mailbox/mails/getReport',
    method: 'post',
    data
  })
}
export function mailReport(data) {
  return request({
    url: 'api-mailbox/mails/mailReport',
    method: 'post',
    data
  })
}
export function GetMails(params) {
  return request({
    url: '/api-mailbox/mails/getMailInfo',
    method: 'post',
    params
  })
}
//延期列表 委办/办理
export function assignDelayListAll(getData) {
  return request({
    url: '/api-mailbox/mails/getMailInfo' + getData,
    method: 'get'
  })
}
//咨询管理
export const conslting = {
  addNew(data) {
    return request({
      url: '/api-common/consult/insert',
      method: 'post',
      data
    })
  },
  getPageList(data) {
    return request({
      url: '/api-common/consult/pageList',
      method: 'post',
      data
    })
  },
  updateOne(data) {
    return request({
      url: '/api-common/consult/update',
      method: 'post',
      data
    })
  },
  realyDel(params) {
    return request({
      url: '/api-common/consult/delById',
      method: 'post',
      params
    })
  }
}

export const colums = {
  getPageList(data) {
    return request({
      url: '/api-supervise/superviseColumn/superviseColumnList',
      method: 'post',
      data
    })
  },
  addColumn(data) {
    return request({
      url: '/api-supervise/superviseColumn/addSuperviseColumn',
      method: 'post',
      data
    })
  },
  delOne(params) {
    return request({
      url: '/api-supervise/superviseColumn/deleteSuperviseColumn',
      method: 'post',
      params
    })
  },
  getOnedetail(params) {
    return request({
      url: '/api-supervise/superviseColumn/selectSuperviseInfoById',
      method: 'post',
      params
    })
  },
  saveOneDetail(data) {
    return request({
      url: '/api-supervise/superviseColumn/updateSuperviseColumn',
      method: 'post',
      data
    })
  }

}
//主题管理
export const themeManage = {

  themePageList_pj_cont(params) {
    return request({
      url: '/api-supervise/superviseComment/selectTotalScoreAndNumByThemeId',
      method: 'post',
      params
    })
  },
  themePageList_pj(data) {
    return request({
      url: '/api-supervise/superviseComment/selectSuperviseCommentList',
      method: 'post',
      data
    })
  },
  saveOneDetail(data) {
    return request({
      url: '/api-supervise/superviseTheme/updateSuperviseTheme',
      method: 'post',
      data
    })
  },
  getOnedetail(params) {
    return request({
      url: '/api-supervise/superviseTheme/superviseThemeInfo',
      method: 'post',
      params
    })
  },
  delThemeOne(params) {
    return request({
      url: '/api-supervise/superviseTheme/deleteSuperviseTheme',
      method: 'post',
      params
    })
  },
  themePageList(data) {
    return request({
      url: '/api-supervise/superviseTheme/superviseThemeList',
      method: 'post',
      data
    })
  },
  getAllWebSites(data) {
    return request({
      url: '/api-supervise/superviseSite/superviseSiteInfo',
      method: 'post',
      data
    })
  },
  getAllColum(data) {
    return request({
      url: '/api-supervise/superviseColumn/superviseColumnBySiteId',
      method: 'post',
      data
    })
  },
  addNewTheme(data) {
    return request({
      url: '/api-supervise/superviseTheme/addSuperviseTheme',
      method: 'post',
      data
    })
  }
}

//委办
export const entrust = {
  GetPageListData(data) {
    return request({
      url: '/api-mailbox/mailOperate/pageList',
      method: 'post',
      data
    })
  },
  delegateReply(data) {
    return request({
      url: '/api-mailbox/mailOperate/delegateReply',
      method: 'post',
      data
    })
  },

}

export const evaluate = {

  updateSuperviseSite(data) {
    return request({
      url: '/api-supervise/superviseSite/updateSuperviseSite',
      method: 'post',
      data
    })
  },
  addWebSite(data) {
    return request({
      url: '/api-supervise/superviseSite/addSuperviseSite',
      method: 'post',
      data
    })
  },
  getWebSiteList(data) {
    return request({
      url: '/api-supervise/superviseSite/superviseSiteList',
      method: 'post',
      data
    })
  },
  deleteSuperviseSite(params) {
    return request({
      url: '/api-supervise/superviseSite/deleteSuperviseSite',
      method: 'post',
      params
    })
  },
  superviseSiteInfo(params) {
    return request({
      url: '/api-supervise/superviseSite/superviseSiteInfo',
      method: 'post',
      params
    })
  },

}

//上面写的太多了，导入的时候不好导，之后用下面这种。
export const letterService = {
  //撤销
  backout(operateId) {
    return request({
      url: `/api-mailbox/mailOperate/recall?operateId=${operateId}`,
      method: 'get'
    })
  },
  //不能选的部门id
  dontSelectIds(getData) {
    return request({
      url: '/api-mailbox/mailOperate/cantAssignDeptIds?operateId=' + getData
    })
  },
  //是否可以回复
  IsReply(getData) {
    return request({
      url: '/api-mailbox/mailOperate/canDo?operateId=' + getData
    })
  },
  //信件回复
  SaveReply(data) {
    return request({
      url: '/api-mailbox/mailOperate/handleReply',
      method: 'post',
      data
    })
  },
  //督办
  UrgeMails(data) {
    return request({
      url: '/api-mailbox/mailReminder/addReminder',
      method: 'post',
      data
    })
  },
  //信件的转办提交
  saveAssignLetter(data) {
    return request({
      url: '/api-mailbox/mailOperate/assign',
      method: 'post',
      data
    })
  },
  //信件的委办提交
  saveWbLetter(data) {
    return request({
      url: '/api-mailbox/mailOperate/addDelegate',
      method: 'post',
      data
    })
  },
  //删除或废弃一条信件
  delSomeoneLetter(params) {
    return request({
      url: '/api-mailbox/mails/disusedMail',
      method: 'post',
      params
    })
  },
  //审核不通过
  noPassTheLetter(data) {
    return request({
      url: '/api-mailbox/mailOperate/assignDelayAudit',
      method: 'post',
      data
    })
  },
  //审核通过
  passTheLetter(data) {
    return request({
      url: '/api-mailbox/mailOperate/assignDelayAudit',
      method: 'post',
      data
    })
  },
  //得到日志
  getLetterLogs(getData) {
    return request({
      url: '/api-mailbox/mailLog/operateLog?bizId=' + getData + '&type=all'
    })
  },
  //得到委办日志
  getLetterLogsWb(getData) {
    return request({
      url: '/api-mailbox/mailLog/operateLog?bizId=' + getData + '&type=delegate'
    })
  },
  //申请延期信件列表
  getBackOrDelayLetterList(getData) {
    return request({
      url: '/api-mailbox/mailOperate/assignDelayList?operateId=' + getData + '&type=all'
    })
  },
  //申请延期信件列表
  getBackOrDelayLetterList2(getData) {
    return request({
      url: '/api-mailbox/mailOperate/assignDelayList?operateId=' + getData
    })
  },
  //退回信件列表
  getReturnBackLetters(getData) {
    return request({
      url: "/api-mailbox/mailOperate/assignBackList?operateId=" + getData
    })
  },
  //退回信件列表
  getBackOrDelayLetterListNoType(getData) {
    return request({
      url: "/api-mailbox/mailOperate/assignBackList?operateId=" + getData
    })
  },
  //点击某条详情的时候触发，查对应的信件文件。
  mailReplyFile(params) {
    return request({
      url: '/api-mailbox/mails/mailReplyFile',
      method: 'post',
      params
    })
  },
  //点击某条详情的时候触发，查前台过来的信件。
  mailReplyFileFront(params) {
    return request({
      url: '/api-mailbox/mails/mailFile',
      method: 'post',
      params
    })
  },
  //公开信件
  publishMail(data) {
    return request({
      url: '/api-mailbox/mails/mailPublish',
      method: 'post',
      data
    })
  },
  //公开参阅
  mailReference(data) {
    return request({
      url: '/api-mailbox/mails/mailReference',
      method: 'post',
      data
    })
  },
  //信件类型，新增信件时的
  letterPurpos(data) {
    return request({
      url: '/api-mailbox/mailType/getMailTypeByConditionList',
      method: 'post',
      data
    })
  },
  //信件内容敏感词检测
  checkContent(data) {
    return request({
      url: '/api-common/sensitive/content',
      method: 'post',
      data
    })
  },
  //信件新增
  addNewLetter(data) {
    return request({
      url: '/api-mailbox/mails/save',
      method: 'post',
      data
    })
  },

  //获取站点
  getAllWebSites(data) {
    return request({
      url: '/api-supervise/superviseSite/superviseSiteInfo',
      method: 'post',
      data
    })
  },

  //设置来信人隐私
  setShowFromInfo(params) {
    return request({
      url: '/api-mailbox/mails/isShowFromInfo',
      method: 'post',
      params
    })
  },
}

export const letterClassify = {
  //更新
  updateDict(data) {
    return request({
      url: '/api-mailbox/dict/updateDict',
      method: 'post',
      data
    })
  },
  //新增
  saveDict(data) {
    return request({
      url: '/api-mailbox/dict/saveDict',
      method: 'post',
      data
    })
  },
  getDictByConditionList(data) {
    return request({
      url: '/api-mailbox/dict/getDictByConditionList',
      method: 'post',
      data
    })
  },
  searchDictByConditionList(data) {
    return request({
      url: '/api-mailbox/dict/selectContentTypeList',
      method: 'post',
      data
    })
  },
  //批量更新
  batchUpdate(data) {
    return request({
      url: '/api-mailbox/mailType/batchUpdate',
      method: 'post',
      data
    })
  },
  //确定删除
  delDictById(data) {
    return request({
      url: '/api-mailbox/dict/delDictById',
      method: 'post',
      data
    })
  }
}

export const purpose = {
  //更新目的
  updateMailType(data) {
    return request({
      url: '/api-mailbox/mailType/updateMailType',
      method: 'post',
      data
    })
  },
  addMailType(data) {
    return request({
      url: '/api-mailbox/mailType/addMailType',
      method: 'post',
      data
    })
  },
  getMailTypeByConditionList(data) {
    return request({
      url: '/api-mailbox/mailType/getMailTypeByConditionList',
      method: 'post',
      data
    })
  },
  searchMailTypeByConditionList(data) {
    return request({
      url: '/api-mailbox/mailType/getMailTypeByConditionList',
      method: 'post',
      data
    })
  },
  batchUpdate(data) {
    return request({
      url: '/api-mailbox/mailType/batchUpdate',
      method: 'post',
      data
    })
  },
  delDictById(data) {
    return request({
      url: '/api-mailbox/dict/delDictById',
      method: 'post',
      data
    })
  }
}

export const handOver = {
  mailReplyFileFront(params) {
    return request({
      url: '/api-mailbox/mails/mailFile',
      method: 'post',
      params
    })
  },
  getAssignId(getData) {
    return request({
      url: '/api-mailbox/assignLog/getAssignId?mailId=' + getData,
    })
  },
  canDoAssign(getData) {
    return request({
      url: '/api-mailbox/assignLog/canDoAssign?assignId=' + getData,
    })
  },
  assignLogDetail(getData) {
    return request({
      url: '/api-mailbox/mailOperate/assignBackDetail?operateId=' + getData,
    })
  },
  delayApply(data) {
    return request({
      url: '/api-mailbox/mailOperate/assignDelayApply',
      method: 'post',
      data
    })
  },
  backMail(data) {
    return request({
      url: '/api-mailbox/mailOperate/assignBack',
      method: 'post',
      data
    })
  },
  assignLogByDeptId(data) {
    return request({
      url: '/api-mailbox/assignLog/assignLogByDeptId',
      method: 'post',
      data
    })
  },
  getMails(data) {
    return request({
      url: '/api-mailbox/mails/getMails',
      method: 'post',
      data
    })
  },
  assignLogByMailIdList(data) {
    return request({
      url: '/api-mailbox/assignLog/assignLogByMailIdList',
      method: 'post',
      data
    })
  },
  getDictConditionList(data) {
    return request({
      url: '/api-mailbox/dict/getDictByConditionList',
      method: 'post',
      data
    })
  },
  //信件类型type,select,办理状态type
  getDictTypeConditionList(data) {
    return request({
      url: '/api-mailbox/dict/getDictByConditionList',
      method: 'post',
      data
    })
  },
  pageList(data) {
    return request({
      url: '/api-mailbox/mailOperate/pageList',
      method: 'post',
      data
    })
  },
  saveDeptReply(data) {
    return request({
      url: '/api-mailbox/mailOperate/assignReply',
      method: 'post',
      data
    })
  },
  updateById(data) {
    return request({
      url: '/api-mailbox/mails/updateById',
      method: 'post',
      data
    })
  },
}

export const statistical = {
  getStatistics(data) {
    return request({
      url: '/api-mailbox/mails/getStatistics',
      method: 'post',
      data
    })
  },
  getStatisticsByParams(data) {
    return request({
      url: '/api-mailbox/mails/getStatisticsByParams',
      method: 'post',
      data
    })
  },
}

/** 意见征集API */
export const opinionCollect = {
  // 获取意见建议类型
  getProposalClasses() {
    return request({
      url: '/api-common/common/businessType?type=BIZ_COLLECT_TYPE',
      method: 'get'
    })
  },
  // 意见建议类型列表
  proposalClassesList(data) {
    return request({
      url: '/api-collect/collectType/pageList',
      method: 'post',
      data
    })
  },
  // 新建意见建议类型
  proposalClassesAdd(data) {
    return request({
      url: '/api-collect/collectType/addType',
      method: 'post',
      data
    })
  },
  // 编辑意见建议类型
  proposalClassesEdit(data) {
    return request({
      url: '/api-collect/collectType/updType',
      method: 'post',
      data
    })
  },
  // 删除意见建议类型
  DelProposalClasses(id) {
    return request({
      url: `/api-collect/collectType/delType?id=${id}`,
      method: 'post'
    })
  },
  pageList(data) {
    return request({
      url: '/api-collect/article/pageList',
      method: 'post',
      data
    })
  },
  getLeaderPageList(data) {
    return request({
      url: '/api-collect/article/leadPageList',
      method: 'post',
      data
    })
  },
  fileLoad(getData) {
    return request({
      url: '/api-collect/article/fileLoad?id=' + getData,
      method: 'post'
    })
  },
  delAttachFileById(getData) {
    return request({
      url: '/api-common/file/delAttachFileById?attachId=' + getData,
      method: 'post'
    })
  },
  detailsPage(getData) {
    return request({
      url: '/api-collect/article/detailsPage?id=' + getData,
      method: 'post'
    })
  },
  delById(getData) {
    return request({
      url: '/api-collect/article/delById?id=' + getData,
      method: 'post'
    })
  },
  insert(data) {
    return request({
      url: '/api-collect/article/insert',
      method: 'post',
      data
    })
  },
  update(data) {
    return request({
      url: '/api-collect/article/update',
      method: 'post',
      data
    })
  },
  opinionPageList(data) {
    return request({
      url: '/api-collect/article/opinionPageList',
      method: 'post',
      data
    })
  },
  opinionDetailsPage(getData) {
    return request({
      url: '/api-collect/article/opinionDetailsPage?id=' + getData,
      method: 'post'
    })
  },
  opinionDelReById(getData) {
    return request({
      url: '/api-collect/article/opinionDelReById?id=' + getData,
      method: 'post'
    })
  },
  dailReply(getData) {
    return request({
      url: '/api-collect/article/dailReply?id=' + getData,
      method: 'post'
    })
  },
  releaseOpinionCollect(params) {
    return request({
      url: '/api-collect/article/publish',
      method: 'post',
      params
    })
  },
  passChoose(params) {
    return request({
      url: '/api-collect/article/audit',
      method: 'post',
      params
    })
  },
  solicitationFeedback(data) {
    return request({
      url: '/api-collect/article/reply',
      method: 'post',
      data
    })
  },
  //敏感词检测
  checkContent(data) {
    return request({
      url: '/api-common/sensitive/content',
      method: 'post',
      data
    })
  }
}

export const questionPaper = {
  //领导视图列表
  getLeaderPageList(data) {
    return request({
      url: '/api-question/questionPaper/leadPageList',
      method: 'post',
      data
    })
  },
  //硬删除问卷
  delPaper(params) {
    return request({
      url: '/api-question/questionPaper/delReById',
      method: 'post',
      params
    })
  },
  //假删除问卷
  notRellyDelPaper(params) {
    return request({
      url: '/api-question/questionPaper/delById',
      method: 'post',
      params
    })
  },
  //设置模版
  setTemplate(params) {
    return request({
      url: '/api-question/questionPaper/template',
      method: 'post',
      params
    })
  },
  getFeedBack(params) {
    return request({
      url: '/api-question/questionPaper/feedback',
      method: 'post',
      params
    })
  },
  questionReply(data) {
    return request({
      url: '/api-question/questionPaper/reply',
      method: 'post',
      data
    })
  },
  publishQuestion(params) {
    return request({
      url: '/api-question/questionPaper/isPublish',
      method: 'post',
      params
    })
  },
  upSort(params) {
    return request({
      url: '/api-question/item/upSort',
      method: 'post',
      params
    })
  },
  downSort(params) {
    return request({
      url: '/api-question/item/downSort',
      method: 'post',
      params
    })
  },
  copyItem(data) {
    return request({
      url: '/api-question/item/copyItem',
      method: 'post',
      data
    })
  },
  yesOrNoOpen(params) {
    return request({
      url: '/api-question/item/isOpen',
      method: 'post',
      params
    })
  },
  questionDelReById(params) {
    return request({
      url: '/api-question/item/delReById',
      method: 'post',
      params
    })
  },
  getQuestionLis(params) {
    return request({
      url: '/api-question/item/select',
      method: 'post',
      params
    })
  },
  getOneQuesDetail(params) {
    return request({
      url: '/api-question/item/dailNaire',
      method: 'post',
      params
    })
  },
  getDetailOfQuestionPaper(params) {
    return request({
      url: '/api-question/questionPaper/detailsPage',
      method: 'post',
      params
    })
  },
  addQuestions(data) {
    return request({
      url: '/api-question/item/insert',
      method: 'post',
      data
    })
  },
  update(data) {
    return request({
      url: '/api-question/item/update',
      method: 'post',
      data
    })
  },
  updateQuestion(data) {
    return request({
      url: '/api-question/questionPaper/update',
      method: 'post',
      data
    })
  },
  addQuestion(data) {
    return request({
      url: '/api-question/questionPaper/insert',
      method: 'post',
      data
    })
  },
  pageList(data) {
    return request({
      url: '/api-question/questionPaper/pageList',
      method: 'post',
      data
    })
  },
  delAnswer(params) {
    return request({
      url: '/api-question/questionPaper/delete',
      method: 'post',
      params
    })
  },
  publicAnwer(params) {
    return request({
      url: '/api-question/questionPaper/audit',
      method: 'post',
      params
    })
  },
  answerDetails(data) {
    return request({
      url: '/api-question/questionPaper/answerDetails',
      method: 'post',
      data
    })
  },
  getDetailOfQuestionPaper(params) {
    return request({
      url: '/api-question/questionPaper/detailsPage',
      method: 'post',
      params
    })
  },
  questionDelReById(params) {
    return request({
      url: '/api-question/item/delReById',
      method: 'post',
      params
    })
  },
  statisticalDetails(params) {
    return request({
      url: '/api-question/questionPaper/statisticalDetails',
      method: 'post',
      params
    })
  },
  getOneQuesDetail(params) {
    return request({
      url: '/api-question/item/dailNaire',
      method: 'post',
      params
    })
  },
  //敏感词检测
  checkContent(data) {
    return request({
      url: '/api-common/sensitive/content',
      method: 'post',
      data
    })
  }
}
//重构别人写的，头疼。
export const onlineInterview = {
  getLeaderInfo(params) {
    return request({
      url: '/api-inter/interview/getGuestList',
      method: 'post',
      params
    })
  },
  getList(data) {
    return request({
      url: '/api-inter/interview/getList',
      method: 'post',
      data
    })
  },
  detail(data) {
    return request({
      url: '/api-inter/interview/detail',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: '/api-inter/interview/delete',
      method: 'post',
      data
    })
  },
  save(data) {
    return request({
      url: '/api-inter/interview/save',
      method: 'post',
      data
    })
  },
  update(data) {
    return request({
      url: '/api-inter/interview/update',
      method: 'post',
      data
    })
  },
  interviewQAList(data) {
    return request({
      url: '/api-inter/interviewQA/interviewQAList ',
      method: 'post',
      data
    })
  },
  findByIdInterviewQA(params) {
    return request({
      url: '/api-inter/interviewQA/interviewQADetail',
      method: 'post',
      params
    })
  },
  answerInterviewQA(data) {
    return request({
      url: '/api-inter/interviewQA/answerInterviewQA',
      method: 'post',
      data
    })
  },
  falseDel(params) {
    return request({
      url: 'api-inter/interviewQA/interviewQADelete',
      method: 'post',
      params
    })
  },
  updateOne(data) {
    return request({
      url: '/api-inter/interview/updateOne',
      method: 'post',
      data
    })
  },
  getOne(data) {
    return request({
      url: '/api-inter/interview/getOne',
      method: 'post',
      data
    })
  },
  setHighLight(data) {
    return request({
      url: '/api-inter/interviewQA/setHighLight',
      method: 'post',
      data
    })
  },
  interviewPicDelete(data) {
    return request({
      url: '/api-inter/interviewPic/delete',
      method: 'post',
      data
    })
  },
  interviewPicUpdate(data) {
    return request({
      url: '/api-inter/interviewPic/update',
      method: 'post',
      data
    })
  },
  saveAttachFilesFront(data) {
    return request({
      url: '/api-common/file/saveAttachFilesFront',
      method: 'post',
      data
    })
  },
  interviewPicList(data) {
    return request({
      url: '/api-inter/interviewPic/getList',
      method: 'post',
      data
    })
  },
  sunmitLeaderInfo(data) {
    return request({
      url: '/api-inter/interview/GuestView',
      method: 'post',
      data
    })
  }
}
//用户管理
export const userManage = {
  pageList(data) {
    return request({
      url: '/api-base/user/pageList',
      method: 'post',
      data
    })
  },
  updatePwd(data) {
    return request({
      url: '/api-base/user/updatePwd',
      method: 'post',
      data
    })
  },
  detail(params) {
    return request({
      url: '/api-base/user/detail',
      method: 'get',
      params
    })
  },
  delById(getData) {
    return request({
      url: '/api-base/user/delId?userId=' + getData,
      method: 'post',
    })
  },
  changeUserInfo(data) {
    return request({
      url: '/api-base/user/update',
      method: 'post',
      data
    })
  },
  addUser(data) {
    return request({
      url: '/api-base/user/add',
      method: 'post',
      data
    })
  },
  deptTree() {
    return request({
      url: '/api-base/department/deptTree',
      method: 'post',
    })
  },
  allRoles() {
    return request({
      url: '/api-base/role/allRoles',
      method: 'get',
    })
  }
}
export const department = {
  deptTree() {
    return request({
      url: '/api-base/department/deptTree',
      method: 'post',
    })
  },
  update(data) {
    return request({
      url: '/api-base/department/update',
      method: 'post',
      data
    })
  },
  insert(data) {
    return request({
      url: '/api-base/department/insert',
      method: 'post',
      data
    })
  },
  departmentDel(params) {
    return request({
      url: '/api-base/department/delById',
      method: 'post',
      params
    })
  },
  pageList(data) {
    return request({
      url: '/api-base/department/pageList',
      method: 'post',
      data
    })
  },
}
export const roles = {
  resTree() {
    return request({
      url: '/api-base/res/resTree?type=MENU',
      method: 'post',
    })
  },
  update(data) {
    return request({
      url: '/api-base/role/update',
      method: 'post',
      data
    })
  },
  allotRes(data) {
    return request({
      url: '/api-base/role/allotRes',
      method: 'post',
      data
    })
  },
  addRole(data) {
    return request({
      url: '/api-base/role/add',
      method: 'post',
      data
    })
  },
  getResTreeByRoleId(getData) {
    return request({
      url: '/api-base/res/getResTreeByRoleId?roleId=' + getData,
    })
  },
  delReId(getData) {
    return request({
      url: '/api-base/role/delReId?roleId=' + getData,
    })
  },
  pageList(data) {
    return request({
      url: '/api-base/role/pageList',
      method: 'post',
      data
    })
  }
}
export const resources = {
  findById(getData) {
    return request({
      url: '/api-base/res/findById?id=' + getData,
      method: 'post'
    })
  },
  delId(getData) {
    return request({
      url: '/api-base/res/delId?id=' + getData,
      method: 'post'
    })
  },
  addResource(data) {
    return request({
      url: '/api-base/res/add',
      method: 'post',
      data
    })
  },
  update(data) {
    return request({
      url: '/api-base/res/update',
      method: 'post',
      data
    })
  },
  resTree() {
    return request({
      url: '/api-base/res/resTree',
      method: 'post',
    })
  },
  allRoles() {
    return request({
      url: '/api-base/role/allRoles',
    })
  },
  pageList(data) {
    return request({
      url: '/api-base/res/pageList',
      method: 'post',
      data
    })
  }
}
export const configs = {
  update(data) {
    return request({
      url: '/api-base/config/update',
      method: 'post',
      data
    })
  },
  insert(data) {
    return request({
      url: '/api-base/config/insert',
      method: 'post',
      data
    })
  },
  delReId(params) {
    return request({
      url: '/api-base/config/delById',
      method: 'post',
      params
    })
  },
  pageList(data) {
    return request({
      url: '/api-base/config/pageList',
      method: 'post',
      data
    })
  }
}
export const dashboard = {

  getWorkbenchApp() {
    return request({
      url: '/api-base/res/selectWorkbenchApplicationByUser',
      method: 'post',
    })
  },
  getTwoMailsNum() {
    return request({
      url: '/api-mailbox/mails/getThreeTypeMailsNum',
      method: 'post',
    })
  },
  undoMail(getData) {
    return request({
      url: '/api-base/backLog/undoMatter?deptId=' + getData,
      method: 'post',
    })
  },
  mailObjectInfo(params) {
    return request({
      url: '/api-mailbox/mails/mailObjectInfo',
      method: 'post',
      params
    })
  },
  brokenLineInfo(data) {
    return request({
      url: '/api-mailbox/mails/mailProcessInfo',
      method: 'post',
      data
    })
  },
  getStatistics(data) {
    return request({
      url: '/api-mailbox/mails/getStatistics',
      method: 'post',
      data
    })
  },
  getInterview(data) {
    return request({
      url: '/api-inter/interviewQA/interviewStatistics',
      method: 'post',
      data
    })
  },
  getInterviewChart(data) {
    return request({
      url: '/api-inter/interviewQA/interProcessInfo',
      method: 'post',
      data
    })
  },
  getThemeChart(data) {
    return request({
      url: '/api-inter/interviewQA/interQAFive',
      method: 'post',
      data
    })
  },
  //上传图片
  uploadScrawl(data) {
    return request({
      url: 'api-common/file/upload?bizType=MAIL_REPLY',
      method: 'post',
      data
    })
  }
}
//获取问卷调查结果
export function getSurvey(params) {
  return request({
    url: "api-netizen/frontQuestionnaire/statisticalDetails",
    method: 'post',
    params
  })
}
//获取图文直播发言列表
export function getLiveSpeak(data) {
  return request({
    url: "api-inter/interviewRecord/getRecordList",
    method: 'post',
    data
  })
}

//新增图文直播
export function addLiveSpeak(data) {
  return request({
    url: "api-inter/interviewRecord/addRecord",
    method: 'post',
    data
  })
}
//更新图文直播
export function updateLiveSpeak(data) {
  return request({
    url: "api-inter/interviewRecord/updateRecord",
    method: 'post',
    data
  })
}
//删除图文直播
export function delLiveSpeak(data) {
  return request({
    url: "api-inter/interviewRecord/deleteRecord",
    method: 'post',
    data
  })
}
//一键发布图文直播
export function publishAllRecord(params) {
  return request({
    url: "api-inter/interviewRecord/publishAllRecord",
    method: 'post',
    params
  })
}
//查询单条图文直播内容
export function getOneRecord(data) {
  return request({
    url: "api-inter/interviewRecord/getRecord",
    method: 'post',
    data
  })
}
//获取excel内容
export function getExcelContent(params) {
  return request({
    url: "/api-mailbox/mails/exportMails",
    method: 'post',
    params
  })
}
export function getExcelContentNew(data) {
  return request({
    url: "/api-mailbox/mails/exportMail",
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}
//获取用户的选择站点数组
export function getSiteInfo(data) {
  return request({
    url: "/api-supervise/superviseSite/deptSite",
    method: 'post',
    data
  })
}

//新增留言接口
export function addLeavaWord(data) {
  return request({
    url: "/api-inter/interviewQA/interviewQAAdd",
    method: 'post',
    data
  })
}
//更新编辑留言
export function editMessage(data) {
  return request({
    url: "/api-inter/interviewQA/interviewQAUpdate",
    method: 'post',
    data
  })
}
//设置是否集锦
export function setHighLight(params) {
  return request({
    url: "/api-inter/interviewQA/setHighLight",
    method: 'post',
    params
  })
}
//设置是否发布
export function setShow(params) {
  return request({
    url: "/api-inter/interviewQA/setShow",
    method: 'post',
    params
  })
}
//设置是否发布
export function exportSiteByExcel(data) {
  return request({
    url: "/api-supervise/superviseSite/selectSiteByIds",
    method: 'post',
    data
  })
}
//获取当前部门站点集合
export function GetDeptSite(data) {
  return request({
    url: "api-supervise/superviseSite/deptSite",
    method: 'post',
    data
  })
}
//获取在线访谈业务类型集合
export function GetLineBusiness(params) {
  return request({
    url: "/api-common/common/businessType?type=BIZ_INTERVIEW.INTERVIEW_TYPE",
    method: 'post',
    params
  })
}

//获取来源站点集合

export function GetSourceSite(params) {
  return request({
    url: "/api-supervise/superviseSite/superviseSiteInfo",
    method: 'post',
    params
  })
}
//删除嘉宾信息
export function delSingleGuest(params) {
  return request({
    url: "api-inter/interview/deleteGuest",
    method: 'post',
    params
  })
}
//获取嘉宾详情
export function getSingleGuest(params) {
  return request({
    url: "api-common/file/getInterviewGuestInfo",
    method: 'get',
    params
  })
}
//修改嘉宾详情
export function changeSingleGuest(data) {
  return request({
    url: "api-inter/interview/updateGuest",
    method: 'post',
    data
  })
}
//导出问卷列表Excel
export function questionExcel(data) {
  return request({
    url: "api-question/questionPaper/export",
    method: 'post',
    data
  })
}
//导出意见征集列表Excel
export function collectExcel(data) {
  return request({
    url: "api-collect/article/export",
    method: 'post',
    data
  })
}
//预览接口
export function previePage(params) {
  return request({
    url: "api-common/common/outjoin",
    method: 'post',
    params
  })
}

//修改审核状态
export function changeAudit(params) {
  return request({
    url: "api-question/questionPaper/audit",
    method: 'post',
    params
  })
}
//删除审核
export function deleteAudit(params) {
  return request({
    url: "api-question/questionPaper/delete",
    method: 'post',
    params
  })
}
//获取审核列表
export function getAuditList(data) {
  return request({
    url: "api-question/questionPaper/answerDetails",
    method: 'post',
    data
  })
}
//获取详情除文本列表
export function getContentDetailsList(data) {
  return request({
    url: "api-question/questionPaper/selDetails",
    method: 'post',
    data
  })
}
//获取详情除文本列表
export function batchDeleteSite(data) {
  return request({
    url: "api-supervise/superviseColumn/deleteBatchColumn",
    method: 'post',
    data
  })
}
//获取关联题目左侧列表
export function getRelevanceItem(data) {
  return request({
    url: "api-question/item/relevanceItem",
    method: 'post',
    data
  })
}
//获取关联题目右侧列表
export function getRelevanceRightList(params) {
  return request({
    url: "api-question/item/relevanceItemOne",
    method: 'post',
    params
  })
}
//保存关联题目
export function saveRelevanceList(data) {
  return request({
    url: "api-question/item/relevance",
    method: 'post',
    data
  })
}
//获取所有站点列表]
export function getAllSite(data) {
  return request({
    url: "api-supervise/superviseSite/selectableSite",
    method: 'post',
    data
  })
}
//修改站点列表ƒ
export function updateSite(data) {
  return request({
    url: "api-supervise/superviseSite/insertSiteIds",
    method: 'post',
    data
  })
}
//获取选择站点列表
export function getChooseSite(data) {
  return request({
    url: "/api-supervise/superviseSite/selectSiteByDeptIdAll",
    method: 'post',
    data
  })
}

//导出站点模版
export function exportModel(data) {
  return request({
    url: "/api-supervise/superviseSite/exportTemplate",
    method: 'post',
    responseType: 'blob',
    data
  })
}
//获取权限部门树
export function getLimitDeptTree(data) {
  return request({
    url: "/api-base/department/findDeptTreeOne",
    method: 'post',
    data
  })
}

//获取词云图数据
export function getWordColouds() {
  return request({
    url: "/api-common/leaderView/wordCloudDiagram",
    method: 'get',
  })
}

//获取热度排行
export function getHeatLists() {
  return request({
    url: "/api-common/leaderView/degreeOfHeatRanking",
    method: 'get',
  })
}

//获取参与度排行
export function getParticipationLists() {
  return request({
    url: "/api-common/leaderView/netizenParticipateRanking",
    method: 'get',
  })
}

//获取热度排行
export function getHunNanMapInfo(data) {
  return request({
    url: "/api-common/leaderView/hotspotMap",
    method: 'post',
    data
  })
}
//互联网+列表
export function GetNetPageListData(data) {
  return request({
    url: '/api-mailbox/mails/netGetPageList',
    method: 'post',
    data
  })
}
//获取互联网查询列表数据
export function GetNetLetterSearch(data) {
  return request({
    url: '/api-mailbox/mails/netGetPageList',
    method: 'post',
    data
  })
}
//获取互联网交办部门树
export function jiaobanNetDeptTree(getData) {
  return request({
    url: '/api-base/department/myDeptTree?operateId=' + getData + '&type=netWork',
    method: 'post'
  })
}
//获取用户管理信息
export function getUserInfo(userId) {
  return request({
    url: '/api-base/user/getUserAuthDept?userId=' + userId,
    method: 'get'
  })
}

//新增修改用户权限模块
export function addUpdateUserModules(data) {
  return request({
    url: '/api-base/user/updateAuthDept',
    method: 'post',
    data
  })
}

// 手动登陆
export function loginSelf(loginName) {
  return request({
    url: `/api-base/login?loginName=${loginName}`,
    method: 'post'
  })
}